var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnlargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 0.6,
    width: 18.8,
    height: 18.8,
    rx: 1.4,
    stroke: "#366CD6",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 17V17.1H4H4.28235H4.38235H4.48235H8.97059H9.07059V17V16.2353V16.1353H8.97059H5.54754L8.47659 13.2062L8.5473 13.1355L8.61801 13.0648L8.61061 13.0574C8.6612 12.9797 8.68872 12.8883 8.68872 12.7941C8.68872 12.6661 8.63785 12.5433 8.5473 12.4527C8.45675 12.3622 8.33394 12.3113 8.20588 12.3113C8.11169 12.3113 8.02034 12.3388 7.94258 12.3894L7.93518 12.382L7.86447 12.4527L7.79375 12.5234L4.86471 15.4525V12.0294V11.9294H4.76471H4H3.9V12.0294V16.5176V16.6176V16.7176V17ZM17.1 4V3.9H17H16.7176H16.6176H16.5176H12.0294H11.9294V4V4.76471V4.86471H12.0294H15.4525L12.5234 7.79375L12.4527 7.86447L12.382 7.93518L12.3894 7.94258C12.3733 7.96737 12.3594 7.99365 12.348 8.02111C12.3238 8.07969 12.3113 8.14248 12.3113 8.20588C12.3113 8.26929 12.3238 8.33207 12.348 8.39065C12.3723 8.44924 12.4079 8.50246 12.4527 8.5473C12.4975 8.59213 12.5508 8.6277 12.6093 8.65196C12.6679 8.67623 12.7307 8.68872 12.7941 8.68872C12.8575 8.68872 12.9203 8.67623 12.9789 8.65197C13.0063 8.64059 13.0326 8.62674 13.0574 8.61061L13.0648 8.61801L13.1355 8.5473L13.2062 8.47659L16.1353 5.54754V8.97059V9.07059H16.2353H17H17.1V8.97059V4.48235V4.38235V4.28235V4Z",
    fill: "#366CD6",
    stroke: "#366CD6",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnlargeIcon);
export default __webpack_public_path__ + "static/media/enlarge-icon.1664f28ccceaf4cb8fd3040e539ca06b.svg";
export { ForwardRef as ReactComponent };